import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { IonContent, IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { IColumnDefinition } from '../types';
import { BasePanelComponent } from './base-panel.component';
import { isEqual } from 'lodash-es';
@Component({
  selector: 'configure-columns-panel',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ion-content #content class="no-scroll">
      <ion-list>
        <ion-reorder-group
          disabled="false"
          (ionItemReorder)="onReorder($any($event))"
        >
          <ion-item *ngFor="let column of updatedColumns; let i = index">
            <ion-checkbox
              slot="start"
              [disabled]="!!column.showAlways"
              [checked]="!column.hidden"
              (ionChange)="onColumnChange(column, i)"
            ></ion-checkbox>
            {{ column.name }}
            <ion-reorder slot="end">
              <ion-icon name="reorder-three-outline"></ion-icon>
            </ion-reorder>
          </ion-item>
        </ion-reorder-group>
      </ion-list>
    </ion-content>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }
    ion-icon {
      opacity: 0.4;
      font-size: 1.5rem;
      color: #0d0d0d
    }
  `,
})
export class ConfigureColumnsPanelComponent implements OnChanges {
  @ViewChild('content', { static: true }) content: IonContent;
  @Input() columns: IColumnDefinition[] = [];
  updatedColumns: IColumnDefinition[] = [];
  private readonly buttons = [
    { key: 'cancel', label: 'Cancel', disabled: false },
    { key: 'ok', label: 'Apply', primary: true, disabled: true },
  ];
  constructor(
    private readonly parent: BasePanelComponent,
    private readonly cd: ChangeDetectorRef,
  ) {
    this.parent.buttons = this.buttons;
    this.cd.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.columns?.currentValue) {
      this.columns = changes.columns.currentValue.map((col) => ({
        ...col,
        hidden: col.hidden ?? false,
      }));
      this.updatedColumns = [...this.columns];
    }
  }

  private isChanged() {
    return isEqual(this.columns, this.updatedColumns);
  }

  onColumnChange(column: IColumnDefinition, index: number) {
    this.updatedColumns[index] = { ...column, hidden: !column.hidden };
    this.buttons[1].disabled = this.isChanged();
    this.cd.markForCheck();
  }

  onReorder(event: CustomEvent<any>) {
    const { detail } = event;
    this.updatedColumns = detail.complete(this.updatedColumns);
    this.buttons[1].disabled = this.isChanged();
    this.cd.markForCheck();
  }

  onFooterAction(key: string) {
    if (key === 'ok') {
      return this.updatedColumns;
    }
    return true;
  }
}
